<template lang="pug">
  .modal.is-active(key="modal-editar")

    .modal-background(@click="closeModalAdd()")
    .card
      header.modal-card-head.display-flex
        p.flex-1
          span(v-if="codigo") Editar tipo de boleta
          span(v-else) Crear tipo de boleta
        span.icon.cursor-pointer(
            @click="$emit('close')"
          )
            i.fa.fa-close
      .card-content
        .title

          .control.margin-bottom-10.flex-1
            p.margin-bottom-5 Código
            input.input.w-90.disabled(
              type="number",
              v-model="codigo"
              disabled="true"
            )

          .control.margin-bottom-10
            p.margin-bottom-5 Descripcion
            input.input.w-300(
              type="text",
              v-model="descripcion"
              :disabled="isLoading"
            )

      footer.card-footer
        a.card-footer-item.is-success(@click="guardar")
          span(v-if="isSaving") Guardando...
          span(v-else) Guardar
        a.card-footer-item( @click="$emit('close')")
          strong Cancelar

</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
export default {
  name: 'gestion-boletas-tipo-editar',
  props: ['codigo'],
  data () {
    return {
      descripcion          : '',
      isSaving             : false,
      isLoading            : false
    }
  },
  mounted () {
    var vm = this
    if (vm.codigo) {
      vm.fetch()
    }
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {
        codigo: vm.codigo
      }

      apiGet(vm, '/boleta/tipos', obj, function (data) {
        vm.codigo       = data.lista[0].codigo
        vm.descripcion = data.lista[0].descripcion
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    guardar () {
      var vm = this

      if (vm.isSaving) return;

      vm.isSaving = true

      var obj = {
      }
      if (vm.codigo) {
        obj.codigo        = vm.codigo
      }
      if (!vm.descripcion) {
        notify(vm, 'error', 'Error', 'Debe ingresar una descripción')
        vm.isSaving = false
        return
      }
      obj.descripcion = vm.descripcion

      apiPost(vm, '/boleta/tipos', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.$emit('closeRefresh')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// c_gestion_boletas_tipo_editar.vue?13d5b4c4